<template lang="pug">
nuxt-link.link(
  v-bind="$attrs"
  :to="computedLink"
)
  span(v-if="props.text") {{ props.text }}
  slot
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type DynamicRouteDestinationProps } from './DynamicRouteDestination.types';
import { dynamicRouteDestinationDefaults } from './DynamicRouteDestination.defaults';

const props = withDefaults(
  defineProps<DynamicRouteDestinationProps>(),
  dynamicRouteDestinationDefaults as any,
) as unknown as DynamicRouteDestinationProps;

const computedLink = computed(() => {
  if (props.generateLink) {
    return props.generateLink();
  }
  return {
    name: props.routeName,
    params: props.params,
    query: props.query,
  };
});
</script>
